// @flow

import * as React from 'react';

import { withPageMeta } from '@gandi/app-runner';
import { useTranslator } from '@gandi/translate';

import { Layout } from 'src/components/Layout';

import { CounterStateProvider } from '../Overview/components/Products/components/components/Rows/Counter';

import type { PreFetchArgs } from '../types';

import { ProductChoice } from './components/Form/components/ProductChoice';

import { Offers } from './components/offers';

import styles from './MailboxSaCreate.scss';

function MailboxStandaloneCreateRoot(): React.MixedElement {
  const translator = useTranslator();
  const { __ } = translator;

  return (
    <Layout>
      <section className={styles.mailboxCreateContainer}>
        <div className={styles.header}>
          <h1 className={styles.mailboxCreateTitle}>
            {__('Creating one or more email addresses')}
          </h1>
          <Offers />
        </div>
        <CounterStateProvider>
          <div className={styles.body}>
            <h2 className={styles.mailboxCreateDescription}>
              {__(
                'Start by choosing the storage option that works best for you.',
              )}
            </h2>
            <div className={styles.choice}>
              <ProductChoice />
            </div>
          </div>
        </CounterStateProvider>
      </section>
    </Layout>
  );
}

export const MailboxStandaloneCreate: React.ComponentType<{}> = withPageMeta(
  args => ({
    title: args.__('Buy mailboxes - Gandi.net'),
    description: args.__('Buy mailboxes.'),
  }),
)(MailboxStandaloneCreateRoot);

// $FlowFixMe[prop-missing]
MailboxStandaloneCreate.preFetchParallel = async (args: PreFetchArgs<>) => {
  return Promise.allSettled([Layout.preFetch(args)]);
};
